import CoursePreview from './CoursePreview'

export default CoursePreview
